/*
 * Formats Brand names so that long names are cut off to avoid display issues
 */
export default function(name, len) {
    if (name.length > len) return name.substring(0, len) + "...";
    else return name
}